export default __webpack_public_path__ + "static/media/Groupe 9056.5cc371e1.svg";